// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"72":"8bfdf5e0","218":"299bb37c","354":"9f5c51cc","423":"86b56cf3","546":"ae953e53","783":"c99e8d4c","809":"23b063b5","887":"5756eca2","973":"bbbbf73a"}[chunkId] + ".css";
};